export default __webpack_public_path__ + "static/media/chat_bot_image9.ac7a4f9d.jpg";